/* import __COLOCATED_TEMPLATE__ from './icon-checkmark.hbs'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--checkmark'],
  viewBox: '-2 -2 15 12',
  width: 16,
  height: 16,
  color: 'black'
});